import {Environment} from "../common/types";

export enum TokTivErrorCodes {
  ERROR_INVALID_PERSONA_TYPE = 1001,
}

export function getCloudHostForEnvironment(env: Environment) {
  switch (env) {
    case Environment.DEBUG:
      return "http://localhost:8080";
    case Environment.EMULATOR:
      return "http://127.0.0.1:5001/fynestudio-apps/us-central1/toktiv";
    default:
    case Environment.PROD:
      return "https://fynestudio-apps-toktiv-api-service.web.app";
  }
}